'use client';

import Toman from '@/app/_components/ui/icons/Toman.svg';

export default function GiftPrice({ price }) {
  return (
    <>
      {price ? (
        <>
          <div className="flex items-center">
            <div className="flex text-xs md:text-sm ">
              <div className="line-through text-gray-100 flex items-center">
                <span className="pl-1">{price.toLocaleString('fa-IR')}</span>

                <Toman />
              </div>

              <span className="onsale bg-color-discount text-white rounded-md py-0.5 px-1.5 text-tiny md:text-sm mr-2 flex items-center">
                %100
              </span>
            </div>
            <div
              className={`sale-price pr-4 flex text-color-price  text-sm  items-center`}
            >
              رایگان
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="text-xs flex items-center  min-h-[57px] ">
            برای اطلاع از قیمت تماس بگیرید
          </div>
        </>
      )}
    </>
  );
}
